import React, { useState, useEffect, useContext } from 'react'
import PoliticalOfficerComp from "./PoliticalOfficerComp";
import { isSteward } from "../../common/checkClient";
import DatePicker from "react-datepicker";

import { AppContext } from "../../AppContext";
import UserSelectBox from "../common/controls/UserSelectBox";

const PoliticalContribDefaultForm = (props)=> {
    const [appContext, setAppContext] = useContext(AppContext);
  const [showCampaign, setShowCampaign] = useState(false);

  const handleNumberFieldDecimalChange = (e) => {
    if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
      props.handleChange(e);
    }
  };


  useEffect(()=>{
    setShowCampaign(props.data.isCampaign === 'Y')
  },[props.data.isCampaign])

    return (
        <div className="form-items mt-4">
                    
        <div className="form-columns">

            <div className="form-column">
            
                <div className="form-item">
                    <label className={`form-item-label required ${props.validation.contribDate ? "" : "warning"}`} htmlFor="contribDate">Contribution or Planned For Date:</label>
                    <div className="form-item-value">
                        <DatePicker selected={props.data.contribDate} onChange={p=>props.handleDateChange(p,"contribDate")}/>
                    </div>
                </div>
                <div className="form-item">
                    <label className={`form-item-label required ${props.validation.description ? "" : "warning" }`} htmlFor="description">Description :</label>
                    <input className="form-item-value" type="text" id="description" name="description" maxLength="500" value={props.data.description} onChange={props.handleChange}/>
                  </div>

                  <div className="form-item">
                    <label className={`form-item-label required ${props.validation.stateProv ? "" : "warning" }`} htmlFor="stateProv">Contribution State/Province :</label>
                    <input className="form-item-value" type="text" id="stateProv" name="stateProv" maxLength="50" value={props.data.stateProv} onChange={props.handleChange}/>
                  </div>

                  <div className="form-item">
                    <label className={`form-item-label required ${props.validation.contribAmount ? "" : "warning" }`} htmlFor="contribAmount">Contribution Amount :</label>
                    <input className="form-item-value" type="text" id="contribAmount" name="contribAmount" value={props.data.contribAmount} onChange={handleNumberFieldDecimalChange}/>
                  </div>

                  <div className="form-item">
                    <label className={`form-item-label required ${props.validation.currency ? "" : "warning" }`} htmlFor="currency">Currency :</label>
                    <input className="form-item-value" type="text" id="currency" name="currency" maxLength="50" value={props.data.currency} onChange={props.handleChange}/>
                  </div>

              <div className="form-item">
                  <label className={`form-item-label required ${props.validation.reqMsrb ? "" : "warning" }`} htmlFor="reqMsrb">Requires MSRB Form G-37?</label>
                  <div className="form-item-value">
                    <div className="full-width label-group">
                      <label>
                        <input type="radio" name="reqMsrb" value="N" className="form-check-input" checked={props.data.reqMsrb === "N"} onChange={props.handleChange}/>
                        No
                      </label>
                      <label>
                        <input type="radio" name="reqMsrb" value="Y" className="form-check-input" checked={props.data.reqMsrb === "Y"} onChange={props.handleChange}/>
                        Yes
                      </label>
                    </div>
                  </div>
              </div>
              <div className="form-item">
                  <label className={`form-item-label required ${props.validation.contribIndividualOrPac ? "" : "warning" }`} htmlFor="contribIndividualOrPac">Is the contribution for an individual candidate or a PAC?</label>
                  <div className="form-item-value">
                    <div className="ml-4 label-group">
                      <label>
                        <input type="radio" name="contribIndividualOrPac" value="IN" className="form-check-input" checked={props.data.contribIndividualOrPac === "IN"} onChange={props.handleChange}/>
                        Individual
                      </label>
                      <label>
                        <input type="radio" name="contribIndividualOrPac" value="PAC" className="form-check-input" checked={props.data.contribIndividualOrPac === "PAC"} onChange={props.handleChange}/>
                        PAC
                      </label>
                    </div>
                  </div>
              </div>
              {isSteward() && props.data.contribIndividualOrPac === "IN" &&
              <div className="form-item">
                  <label className={`form-item-label required ${props.validation.contribIndividualSoughtPosition ? "" : "warning" }`} htmlFor="contribIndividualSoughtPosition">What level is the position being sought at?</label>
                  <div className="form-item-value">
                    <div className="ml-4 label-group">
                      <label>
                        <input type="radio" name="contribIndividualSoughtPosition" value="ST" className="form-check-input" checked={props.data.contribIndividualSoughtPosition === "ST"} onChange={props.handleChange}/>
                        Local/State
                      </label>
                      <label>
                        <input type="radio" name="contribIndividualSoughtPosition" value="FED" className="form-check-input" checked={props.data.contribIndividualSoughtPosition === "FED"} onChange={props.handleChange}/>
                        Federal
                      </label>
                    </div>
                  </div>
              </div>
              }
              {isSteward() && props.data.contribIndividualOrPac === "IN" &&
              <div className="form-item">
                  <label className={`form-item-label required ${props.validation.contribIndividualHoldOffice ? "" : "warning" }`} htmlFor="contribIndividualHoldOffice">Does the candidate you are contributing to currently hold an existing office?</label>
                  <div className="form-item-value">
                    <div className="ml-4 label-group">
                      <label>
                        <input type="radio" name="contribIndividualHoldOffice" value="N" className="form-check-input" checked={props.data.contribIndividualHoldOffice === "N"} onChange={props.handleChange}/>
                        No
                      </label>
                      <label>
                        <input type="radio" name="contribIndividualHoldOffice" value="Y" className="form-check-input" checked={props.data.contribIndividualHoldOffice === "Y"} onChange={props.handleChange}/>
                        Yes
                      </label>
                    </div>
                  </div>
              </div>
              }
              {isSteward() && props.data.contribIndividualOrPac === "IN" && props.data.contribIndividualHoldOffice === "Y" &&
              <div className="form-item">
                  <label className={`form-item-label required ${props.validation.contribIndividualActivePosition ? "" : "warning" }`} htmlFor="contribIndividualActivePosition">At what level does the official currently hold an active position?</label>
                  <div className="form-item-value">
                    <div className="ml-4 label-group">
                      <label>
                        <input type="radio" name="contribIndividualActivePosition" value="ST" className="form-check-input" checked={props.data.contribIndividualActivePosition === "ST"} onChange={props.handleChange}/>
                        Local/State
                      </label>
                      <label>
                        <input type="radio" name="contribIndividualActivePosition" value="FED" className="form-check-input" checked={props.data.contribIndividualActivePosition === "FED"} onChange={props.handleChange}/>
                        Federal
                      </label>
                    </div>
                  </div>
              </div>
              }
              <div className="form-item">
                  <label className="form-item-label required" htmlFor="contributorEligibleToVote">Is the contributor eligible to vote for the candidate?</label>
                  <div className="form-item-value">
                    <div className="ml-4 label-group">
                      <label>
                        <input type="radio" name="contributorEligibleToVote" value="N" className="form-check-input" checked={props.data.contributorEligibleToVote === "N"} onChange={props.handleChange}/>
                        No
                      </label>
                      <label>
                        <input type="radio" name="contributorEligibleToVote" value="Y" className="form-check-input" checked={props.data.contributorEligibleToVote === "Y"} onChange={props.handleChange}/>
                        Yes
                      </label>
                    </div>
                  </div>
              </div>

            </div>

            <div className="form-column">

              <div className="form-item">
                  <label className={`form-item-label required ${props.validation.politicalParty ? "" : "warning" }`} htmlFor="politicalParty">Political Party or Subdivision :</label>
                  <input className="form-item-value" type="text" id="politicalParty" name="politicalParty" maxLength="200" value={props.data.politicalParty} onChange={props.handleChange}/>
              </div>

              <div className="form-item">

                  <label className={`form-item-label required ${props.validation.campaign ? "" : "warning" }`} htmlFor="campaign">Part of Bond Ballot Campaign :</label>
                  <div className="form-item-value">
                    <div className="full-width label-group">
                      <label>
                        <input type="radio" name="isCampaign" value="N" className="form-check-input" checked={props.data.isCampaign === "N"} onChange={props.handleChange}/>
                        No
                      </label>
                      <label>
                        <input type="radio" name="isCampaign" value="Y" className="form-check-input" checked={props.data.isCampaign === "Y"} onChange={props.handleChange}/>
                        Yes
                      </label>
                      <label>(If Yes, please specify)</label>
                    </div>
                    <textarea disabled={!showCampaign} rows="3" className="full-width"  id="campaign" name="campaign" maxLength="200" value={props.data.campaign} onChange={props.handleChange}/>
                  </div>
              </div>

              <div className="form-item">
                <label className="form-item-label">Officials :</label>
                <div className="form-item-value">
                  <PoliticalOfficerComp list={props.officials} onAdd={props.officialAdd} onRemove={props.officialRemove} onChange={props.officialChanged} />
                </div>
            </div>

              <div className="form-item">
                  <label className="form-item-label" htmlFor="attachment">Attachment Document :</label>
                  <div className="form-item-value placeholder">
                      <input type="file" name="attachment" id="attachment" onChange={props.handleChange}/>
                  </div>
              </div>

            <div className="form-item">
                {appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                    <UserSelectBox label='Submit On Behalf of (Optional) : ' styleClass='mt-3rem' onSelected={props.handleChange} name='submittedFor' value={() => { return props.data.submittedFor ? { value: props.data.submittedFor, label: props.data.submittedForLabel } : null }} />
                }
            </div>




            </div>

        </div>

    </div>
    )
}

export default PoliticalContribDefaultForm
